module.exports = __webpack_public_path__ + "app/assets/images/man16-be930053403765fbe59746d3aefb3699.jpg";